export default [
  {
    path: "/dashboard/analytics",
    name: "dashboard-analytics",
    redirect: { name: "menu-clients" },
    component: () => import("@/views/dashboard/analytics/Analytics.vue"),
    meta: {
      authRequired: true,
    },
  },
  {
    path: "/dashboard/ecommerce",
    name: "dashboard-ecommerce",
    component: () => import("@/views/dashboard/ecommerce/Ecommerce.vue"),
    meta: {
      authRequired: true,
    },
  },
];
